import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Card,
  CardHeader,
  Typography,
  Button,
  Box,
  TextField,
} from "@mui/material";
import { imgUrl, url } from "src/Helpers/utils/Constant";
import axios from "axios";
import Toaster from "src/Toaster/Toaster";
import { useNavigate } from "react-router-dom";
import { ISingleBusinessLicense } from "src/Types/module/UpdateRequest/RequestBusinessLicense";
import { useAuthContext } from "src/components/Context/AuthContext/AuthContext";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useState } from "react";

interface IProps {
  id: number | string;
  requestBusinessLicenseInfo: ISingleBusinessLicense;
}

const UpdateBusinessLicenseInfo = ({
  id,
  requestBusinessLicenseInfo,
}: IProps) => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  const handelAccept = async () => {
    try {
      const { data } = await axios.post(
        `${url}/api/atab/member-company/update-request/member/business-license/${id}?user_admin_id=${user.user_admin_id}`
      );
      if (data.success) {
        Toaster().fire({
          icon: "success",
          title: data.message,
        });
        navigate("/update-request/business-license");
      }
    } catch (err: any) {}
  };

  const handelReject = async () => {
    setLoading(true);
    if (!rejectReason) {
      setLoading(false);
      return Toaster().fire({
        icon: "error",
        title: "Please enter reject reason",
      });
    }
    try {
      const { data } = await axios.post(
        `${url}/api/atab/member-company/update-request/member/business-license/${id}?confirmation_type=reject&user_admin_id=${user.user_admin_id}`,
        {
          reject_reason: rejectReason,
        }
      );
      if (data.success) {
        Toaster().fire({
          icon: "success",
          title: data.message,
        });
        navigate("/update-request/business-license");
        setLoading(false);
      }
    } catch (err: any) {
      Toaster().fire({
        icon: "error",
        title: err?.response?.data.message,
      });
      setLoading(false);
    }
  };

  return (
    <>
      <Card>
        <CardHeader
          title={
            <Typography variant="h4" fontSize={21}>
              Requested information
            </Typography>
          }
          action={
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Button size="small" variant="outlined" onClick={handelAccept}>
                Accept request
              </Button>
              <Button
                size="small"
                variant="outlined"
                color="error"
                onClick={() => setOpen(true)}
              >
                Reject request
              </Button>
            </Box>
          }
        />
        <TableContainer sx={{ mb: 5 }}>
          <Table aria-label="custom pagination table">
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  Hajj license
                </TableCell>
                <TableCell align="right">
                  {requestBusinessLicenseInfo?.hajj_license ? "Yes" : "No"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell component="th" scope="row">
                  Hajj license file
                </TableCell>
                <TableCell align="right">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`${imgUrl}/${requestBusinessLicenseInfo.hajj_license_file}`}
                  >
                    {requestBusinessLicenseInfo.hajj_license_file}
                  </a>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell component="th" scope="row">
                  Umrah license
                </TableCell>
                <TableCell align="right">
                  {requestBusinessLicenseInfo?.umrah_license ? "Yes" : "No"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell component="th" scope="row">
                  Umrah license file
                </TableCell>
                <TableCell align="right">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`${imgUrl}/${requestBusinessLicenseInfo.umrah_license_file}`}
                  >
                    {requestBusinessLicenseInfo.umrah_license_file}
                  </a>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell component="th" scope="row">
                  Recruting license
                </TableCell>
                <TableCell align="right">
                  {requestBusinessLicenseInfo?.recruting_license ? "Yes" : "No"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell component="th" scope="row">
                  Recruting license file
                </TableCell>
                <TableCell align="right">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`${imgUrl}/${requestBusinessLicenseInfo.recruting_license_file}`}
                  >
                    {requestBusinessLicenseInfo.recruting_license_file}
                  </a>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell component="th" scope="row">
                  Tourism activities inbound
                </TableCell>
                <TableCell align="right">
                  {requestBusinessLicenseInfo?.inbound ? "Yes" : "No"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Tourism activities outbound
                </TableCell>
                <TableCell align="right">
                  {requestBusinessLicenseInfo?.outbound ? "Yes" : "No"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <ModalsWrapper
        modalData={{ title: "Rejected reason" }}
        setShowModal={setOpen}
        showModal={open}
      >
        <Box
          sx={{
            mx: 4,
          }}
        >
          <TextField
            margin="normal"
            required
            rows={4}
            fullWidth
            id="reason"
            label="Rejected reason"
            placeholder="Rejected reason"
            onChange={(e) => setRejectReason(e.target.value)}
            type="text"
            multiline
            autoFocus
          />

          {loading ? (
            <Button
              fullWidth
              variant="contained"
              disableElevation
              sx={{
                mt: 3,
                mb: 2,
                py: 1,
              }}
            >
              Loading ...
            </Button>
          ) : (
            <Button
              onClick={handelReject}
              fullWidth
              variant="contained"
              disableElevation
              sx={{
                mt: 3,
                mb: 2,
                py: 1,
              }}
            >
              Submit
            </Button>
          )}
        </Box>

        {/* <CreateMember setAllMembers={setAllMembers} handleClose={setOpen} /> */}
      </ModalsWrapper>
    </>
  );
};

export default UpdateBusinessLicenseInfo;
